import { useContext, useState } from "react";
import { Box, Button, Grid, Stack, Typography, Fade } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//Import from project
import "./studentdetail.scss";
import { StudentCard } from "../../../Student/StudentDetail/StudentCard";
import { AuthContext } from "../../../../Context/AuthContext";
import EmptyData from "../../../../Components/Include/EmptyData/EmptyData";
import ClassCard from "./ClassCard/ClassCard";
import CreateIcon from "../../../../Assets/create-icon.svg";
import LoadingPage from "../../../../Utils/LoadingPage";
import useGetClassById from "../../../../Hooks/useGetClassById";
import useGetStudentById from "../../../../Hooks/useGetStudentById";
import AssignClassToStudentForm from "../../../Student/StudentDetail/AssignClassToStudentForm";
import useGetEnrollmentByStudent from "../../../../Hooks/useGetEnrollmentByStudent";

import Payment from "../../../StudyClass/PaymentForStudent/PaymentForStudent";
import Homework from "../../../StudyClass/HomeworkForStudent/HomeworkForStudent";
import TeachingTime from "../../../StudyClass/TeachingTimeForStudent/TeachingTimeForStudent";

export const StudentDetailInClass = () => {
  // Change Language
  const { t } = useContext(AuthContext);

  const [studentTab, setStudentTab] = useState("homework");

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let classId = params.get("classId");
  let studentId = params.get("studentId");

  const { studentEnrollmentData, refetch, loading } = useGetEnrollmentByStudent(
    {
      id: studentId,
      status: "all",
    }
  );

  // console.log("studentEnrollmentData::", studentEnrollmentData)

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { studentData } = useGetStudentById({ id: studentId });
  const { classData } = useGetClassById({ id: classId });

  const navigate = useNavigate();

  const tabItems = [
    { value: "homework", label: t("thead_homework") },
    { value: "teaching-time", label: t("thead_teaching_time") },
    { value: "payment", label: t("thead_payment") },
    { value: "class", label: t("thead_class") },
  ];

  const componentMap = {
    homework: Homework,
    "teaching-time": TeachingTime,
    payment: Payment,
  };

  const ActiveComponent = componentMap[studentTab];
  // Props passed to each tab component
  const tabPropsMap = {
    homework: { studentId },
    "teaching-time": { studentId },
    payment: { studentId },
  };

  const activeProps = tabPropsMap[studentTab] || {};

  // console.log("tabPropsMap::", activeProps)

  return (
    <Stack direction="column" spacing={2}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box className="slash" />
        <Typography
          className={t("class-page-title")}
          onClick={() => navigate(`/class/class-detail?classId=${classId}`)}
        >
          {classData?.courseId?.enName + " " + classData?.className}
        </Typography>
        <Typography className={"slash-title"}>/</Typography>
        <Typography className={t("class-page-title")}>
          {studentData?.familyName + " " + studentData?.studentName}
        </Typography>
      </Stack>

      <Box>
        <Grid item container spacing={4}>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <StudentCard />
          </Grid>

          {/* ====================================== Class card ================================== */}
          <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
            <Stack direction="column" spacing={2} sx={{ marginTop: "30px" }}>
              {/* <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                className="tab-container"
                sx={{ position: "relative", marginTop: 5 }}
              >
                <Box
                  sx={{ position: "absolute", bottom: "-2px", width: "100%" }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Stack direction="row">
                      <Button
                        className={
                          studentTab === "studying"
                            ? t("class-name-tab-item-active")
                            : t("class-name-tab-item")
                        }
                        onClick={() => setStudentTab("studying")}
                      >
                        {t("thead_studying")}
                      </Button>

                      <Button
                        className={
                          studentTab === "complete"
                            ? t("class-name-tab-item-active")
                            : t("class-name-tab-item")
                        }
                        onClick={() => setStudentTab("complete")}
                      >
                        {t("thead_completed")}
                      </Button>

                      <Button
                        className={
                          studentTab === "dropout"
                            ? t("class-name-tab-item-active")
                            : t("class-name-tab-item")
                        }
                        onClick={() => setStudentTab("dropout")}
                      >
                        {t("thead_dropout")}
                      </Button>
                    </Stack>
                    <Button
                      onClick={handleOpen}
                      className="btn-create"
                      startIcon={
                        <img
                          src={CreateIcon}
                          alt="CreateIcon"
                          className="icon-add"
                        />
                      }
                    >
                      {t("create")}
                    </Button>

                    {open && (
                      <AssignClassToStudentForm
                        open={open}
                        studentId={studentId}
                        handleClose={handleClose}
                        setRefetch={refetch}
                      />
                    )}
                  </Stack>
                </Box>
              </Stack> */}

              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                className="tab-container"
                sx={{ position: "relative" }}
              >
                <Box
                  sx={{ position: "absolute", bottom: "-2px", width: "100%" }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Stack direction="row">
                      {tabItems.map((tab) => (
                        <Button
                          key={tab.value}
                          className={
                            studentTab === tab.value
                              ? t("class-name-tab-item-active")
                              : t("class-name-tab-item")
                          }
                          onClick={() => setStudentTab(tab.value)}
                        >
                          {tab.label}
                        </Button>
                      ))}
                    </Stack>

                    {studentTab === "class" && (
                      <Button
                        onClick={handleOpen}
                        className="btn-create"
                        startIcon={
                          <img
                            src={CreateIcon}
                            alt="Create"
                            className="icon-add"
                          />
                        }
                      >
                        {t("create")}
                      </Button>
                    )}

                    {open && (
                      <AssignClassToStudentForm
                        open={open}
                        setRefetch={refetch}
                        studentId={studentId}
                        handleClose={handleClose}
                        dialogTitle="Create"
                      />
                    )}
                  </Stack>
                </Box>
              </Stack>

              {/* <Grid container spacing={2} sx={{ mt: 0.4 }}>
                {loading ? (
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        height: 320,
                        width: "100%",
                        bgcolor: "white",
                        borderRadius: 1,
                      }}
                    >
                      <LoadingPage />
                    </Stack>
                  </Grid>
                ) : studentEnrollmentData?.length === 0 ? (
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        height: 320,
                        width: "100%",
                        bgcolor: "white",
                        borderRadius: 1,
                      }}
                    >
                      <EmptyData />
                    </Stack>
                  </Grid>
                ) : (
                  studentEnrollmentData?.map((data, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={index}>
                      <ClassCard data={data} setRefetch={refetch} />
                    </Grid>
                  ))
                )}
              </Grid> */}

              {/* Tab Content */}
              <Fade in={true} timeout={400} key={studentTab}>
                <Box width="100%">
                  {ActiveComponent ? (
                    <ActiveComponent {...activeProps} />
                  ) : (
                    <Grid container spacing={2} sx={{ mt: 0.05 }}>
                      {loading ? (
                        <Grid item xs={12}>
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              height: 320,
                              width: "100%",
                              bgcolor: "white",
                              borderRadius: 1,
                            }}
                          >
                            <LoadingPage />
                          </Stack>
                        </Grid>
                      ) : studentEnrollmentData?.length === 0 ? (
                        <Grid item xs={12}>
                          <Stack
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                              height: 320,
                              width: "100%",
                              bgcolor: "white",
                              borderRadius: 1,
                            }}
                          >
                            <EmptyData />
                          </Stack>
                        </Grid>
                      ) : (
                        studentEnrollmentData?.map((data, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            xl={3}
                            key={index}
                          >
                            <ClassCard data={data} setRefetch={refetch} />
                          </Grid>
                        ))
                      )}
                    </Grid>
                  )}
                </Box>
              </Fade>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};
